import IframeService from '../abstract/IframeService';

export default class IframeManager extends IframeService {
  private iframeRef: HTMLIFrameElement;

  constructor() {
    super('IframeManager');
  }

  public injectIframe(iframe: HTMLIFrameElement): void {
    this.iframeRef = iframe;
  }

  public changeIframeSrc(src: string): void {
    // get the curent url and add the new path
    let currentUrl = new URL(this.iframeRef.src);

    // set the new path
    currentUrl.pathname = src;

    // set the new url
    src = currentUrl.toString();

    this.iframeRef.src = src;
  }
}
